function HourSelector({
  className,
  disabled,
  militaryTime,
  onChange,
  value,
}: {
  className?: string;
  disabled?: boolean;
  militaryTime?: boolean;
  onChange: (hour: number) => void;
  value?: number;
}): JSX.Element | null {
  const hours = militaryTime
    ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
    : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <select
      className={`cursor-pointer focus:z-50 ${className ? className : ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      disabled={disabled}
      onChange={(e) => onChange(parseInt(e.target.value))}
      style={{ direction: "rtl" }}
      value={value}
    >
      {!value && <option value="">--</option>}
      {hours.map((hour) => (
        <option key={hour}>{hour}</option>
      ))}
      )
    </select>
  );
}

export default HourSelector;
